import {
  IPlayerStanding,
  IPlayerStandingInput
} from "@/hooks/usePlayerStanding/types"

export const derivePlayerStanding = ({
  plan,
  snapshotMoving,
  standing
}: IPlayerStandingInput): IPlayerStanding => ({
  isMoving: plan === "present" || (plan === "not-loaded" && snapshotMoving),
  standing
})
